/**
 * Menu Items Grid Component
 * Grid layout for displaying menu item cards
 */

import React from 'react';
import { MenuItem } from '../../../../types/menu';
import { MenuItemCard } from './MenuItemCard';

interface MenuItemsGridProps {
  canManageMenu?: boolean;
  items: MenuItem[];
  onEdit: (item: MenuItem) => void;
  onDelete: (item: MenuItem) => void;
  formatPrice: (price: number) => string;
}

export const MenuItemsGrid: React.FC<MenuItemsGridProps> = ({
  canManageMenu = true,
  items,
  onEdit,
  onDelete,
  formatPrice,
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
      {items.map((item) => (
        <MenuItemCard
          key={item.id}
          canManageMenu={canManageMenu}
          item={item}
          onEdit={onEdit}
          onDelete={onDelete}
          formatPrice={formatPrice}
        />
      ))}
    </div>
  );
};
